import { TipoMail } from 'src/app/pages/configuracion/Envios/envios/models/tipo-mail';

export type OrigenContacto = 'Personal' | 'Profesional';

export const ORDEN_CONTACTO_PERSONAL = 'Personal';
export const ORDEN_CONTACTO_PROFESIONAL = 'Profesional';

export const DESC_ORIGEN_PERSONAL_FALLBACK = 'Personal, si no existe, profesional';
export const DESC_ORIGEN_PROFESIONAL_FALLBACK = 'Profesional, si no existe, personal';

/** Normaliza codigo/desc de catalogo a Personal | Profesional. */
export function normalizarOrigenContacto(codigoODesc: string | null | undefined): OrigenContacto {
  const valor = (codigoODesc ?? '').trim().toLowerCase();
  if (!valor) {
    return ORDEN_CONTACTO_PERSONAL;
  }
  if (valor === 'profesionalopersonal' || valor.startsWith('profesional')) {
    return ORDEN_CONTACTO_PROFESIONAL;
  }
  if (valor === 'personaloprofesional' || valor.startsWith('personal')) {
    return ORDEN_CONTACTO_PERSONAL;
  }
  if (valor.includes('profes') && !valor.includes('personal')) {
    return ORDEN_CONTACTO_PROFESIONAL;
  }
  return ORDEN_CONTACTO_PERSONAL;
}

/**
 * Preferido primero; si vacio, el otro origen.
 * Profesional → profesional || personal; Personal → personal || profesional.
 */
export function resolverContactoConFallback(
  preferido: OrigenContacto | string,
  personal: string | null | undefined,
  profesional: string | null | undefined
): string {
  const origen = normalizarOrigenContacto(preferido);
  const valorPersonal = (personal ?? '').trim();
  const valorProfesional = (profesional ?? '').trim();
  if (origen === ORDEN_CONTACTO_PROFESIONAL) {
    return valorProfesional || valorPersonal;
  }
  return valorPersonal || valorProfesional;
}

export function formatearTelefonoContacto(
  extension: string | null | undefined,
  numero: string | null | undefined
): string {
  const ext = (extension ?? '').trim();
  const num = (numero ?? '').trim();
  if (!ext && !num) {
    return '';
  }
  return `${ext}${num}`.trim();
}

/** Dos opciones con texto corto de fallback para correo y SMS. */
export function filtrarOpcionesOrigenContacto(_tipos: TipoMail[] | null | undefined): TipoMail[] {
  return [
    { codigo: ORDEN_CONTACTO_PERSONAL, desc: DESC_ORIGEN_PERSONAL_FALLBACK },
    { codigo: ORDEN_CONTACTO_PROFESIONAL, desc: DESC_ORIGEN_PROFESIONAL_FALLBACK }
  ];
}

export function descripcionOrigenContacto(
  opciones: TipoMail[],
  codigo: string | null | undefined
): string {
  const origen = normalizarOrigenContacto(codigo);
  const match = opciones.find(
    opcion =>
      normalizarOrigenContacto(opcion.codigo) === origen ||
      normalizarOrigenContacto(opcion.desc) === origen
  );
  return match?.desc ?? (origen === ORDEN_CONTACTO_PROFESIONAL
    ? DESC_ORIGEN_PROFESIONAL_FALLBACK
    : DESC_ORIGEN_PERSONAL_FALLBACK);
}
